import { Injectable, inject } from '@angular/core';
import { AbstractOrderUIService } from '../abstract/abstract-order-ui-service';
import { OrderModel } from 'src/app/store/order/model';
import notify from 'devextreme/ui/notify';
import { TranslateService } from '@ngx-translate/core';
import { OrderConstants } from '../../constants/order-constants';

@Injectable()
export class OrderUIService extends AbstractOrderUIService {
  private translate = inject(TranslateService);

  isDisabled(order: OrderModel): boolean {
    if (order && order.id) {
      return true;
    }

    return false;
  }

  validateFiles(files: any[]): boolean {
    var result = true;

    if (files) {
      for (let index = 0; index < files.length; index++) {
        let file = files[index];
        let fileExtension = file.name.substr(file.name.lastIndexOf('.')).toLowerCase();

        if (!OrderConstants.SupportedFileFormat.find(x => x === fileExtension)) {
          this.translate.get('NOT_SUPPORT_FILE_FORMAT').subscribe(value => {
            notify(value + file.name, 'error', 3000);
          });
          result = false;
          break;
        }

        if (file.size > OrderConstants.MaxFileSize) {
          this.translate.get('EXCEEDED_FILE_SIZE').subscribe(value => {
            notify(value + file.name, 'error', 3000);
          });
          result = false;
          break;
        }
      }

      return result;
    }
  }
}
